import { message } from 'antd'
import { fetchUtil as fetch, buildQuery, manualFetch } from 'src/utils/fetch'

export const getAll = async (params) => {
  try {
    const query = buildQuery(params)
    const { data } = await fetch(`/playlist/images?${query}`)
    return data
  } catch (e) {
    message.error('getAllImages error')
  }
}

export const create = async (type: ImageType, file: any) => {
  try {
    const body = new FormData()
    body.append('image', file, file.name)
    body.append('type', type)
    const { data } = await fetch(`/playlist/images/upload`, {
      method: 'POST',
      body,
    })
    return data
  } catch (e) {
    message.error('create image error')
  }
}

export const update = async (id: string, file: any) => {
  try {
    const body = new FormData()
    body.append('image', file, file.name)
    const { data } = await fetch(`/playlist/images/${id}`, {
      method: 'PATCH',
      body,
    })
    return data
  } catch (e) {
    message.error('update image error')
  }
}

export const updateOrCreate = async (
  id: string,
  payload: Record<string, any>
) => {
  try {
    let res = null
    if (id && id !== 'new') {
      res = await update(id, payload.image.file)
    } else {
      res = await create(payload.type, payload.image.file)
    }
    return res
  } catch (e) {
    message.error('updateOrCreate image error !')
    throw e
  }
}

export const remove = async (id: string) => {
  try {
    const { data } = await fetch(`/playlist/images/${id}`, {
      method: 'DELETE',
    })
    return data
  } catch (e) {
    message.error('remove images error')
  }
}

export const download = async (id, type) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/metaverse-rooms/file/download?imagePath=${id}&type=${type}`
    return manualFetch(url, {
      headers: {
        accept: 'image/*',
      },
    })
      .then((response) => response.blob())
      .then((imageBlob) => {
        const imageUrl = URL.createObjectURL(imageBlob)
        return imageUrl
      })
  } catch (e) {
    message.error('remove images error')
  }
}

export const downloadImageById = async (attachmentId) => {
  const url = `${process.env.REACT_APP_API_URL}/api/social/posts/${attachmentId}/download`
  return manualFetch(url, {
    headers: {
      accept: 'image/*',
    },
  })
    .then((response) => response.blob())
    .then((imageBlob) => {
      return URL.createObjectURL(imageBlob)
    })
}

export const downloadAttachment = async (id, type) => {
  const fileContents = []
  if (!id) return fileContents

  const url = `${process.env.REACT_APP_API_URL}/api/social/posts/${id}/download`

  const response = await manualFetch(url, {
    headers: {
      accept: '*/*',
    },
  })

  const blob = await response.blob()

  const contentDisposition = response.headers.get('Content-Disposition')
  let filename = 'attachment'

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/)
    if (match) {
      filename = match[1]
    }
  }

  fileContents.push({
    blobUrl: URL.createObjectURL(blob),
    filename,
    fileType: type,
  })

  return fileContents
}
